(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-is-user-afk.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/hooks/use-is-user-afk.js');
"use strict";

const {
  useEffect
} = React;
const {
  useAtomValue,
  useSetAtom
} = jotai;
const {
  charityAtom
} = svs.lyckoplatsen.shared_charity.jotai.atoms;
const {
  isMovingAtom,
  isUserIdleAtom,
  mapZoomLevelAtom
} = svs.lyckoplatsen.shared_map.atoms;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const {
  pinLocationAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
setGlobal('svs.lyckoplatsen.components.page_play.react.hooks', {
  useIsUserAfk: () => {
    const pinLocation = useAtomValue(pinLocationAtom);
    const isMoving = useAtomValue(isMovingAtom);
    const setIsUserIdle = useSetAtom(isUserIdleAtom);
    const charity = useAtomValue(charityAtom);
    const zoomLevel = useAtomValue(mapZoomLevelAtom);
    const idleTime = charity ? 500 : 6000;
    useEffect(() => {
      let timerAfterId;
      if (!isMoving && zoomLevel < CONSTANTS.PLACE_PIN_ZOOM_LEVEL) {
        timerAfterId = setTimeout(() => {
          setIsUserIdle(true);
        }, idleTime);
      }
      if (pinLocation.lng || isMoving || zoomLevel >= CONSTANTS.PLACE_PIN_ZOOM_LEVEL) {
        clearTimeout(timerAfterId);
        setIsUserIdle(false);
      }
      return () => clearTimeout(timerAfterId);
    }, [isMoving, idleTime, pinLocation, setIsUserIdle, zoomLevel]);
  }
});

 })(window);